

<h1 class="page-header">NordNative Privacy Policy</h1>

<style>
    .container {
        max-width: 800px;
        margin: 50px auto;
        padding: 20px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    p {
        margin-bottom: 15px;
    }

    ul {
        margin: 15px 0;
        padding-left: 20px;
    }

    li {
        margin-bottom: 10px;
    }

    a {
        color: #2a7df2;
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }
</style>

<div class="container">
    <p>Welcome to NordNative! Your privacy is critically important to us. This Privacy Policy explains how we
        collect, use, and protect your personal information when you visit or use our website and services.</p>

    <h2>1. Information We Collect</h2>
    <p>We may collect the following types of information:</p>
    <ul>
        <li><strong>Personal Information:</strong> Name, email address, phone number, and payment information when
            you sign up or purchase our services.</li>
        <li><strong>Usage Data:</strong> Information about how you use our website and services, including IP
            address, browser type, and operating system.</li>
        <li><strong>Cookies:</strong> Data collected through cookies and similar technologies to enhance your
            browsing experience.</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <p>We use the information we collect for the following purposes:</p>
    <ul>
        <li>To provide and maintain our services.</li>
        <li>To improve and personalize your experience on our platform.</li>
        <li>To process transactions and communicate with you regarding your account.</li>
        <li>To send promotional materials or special offers (only if you have opted in).</li>
        <li>To comply with legal obligations or resolve disputes.</li>
    </ul>

    <h2>3. Sharing Your Information</h2>
    <p>We will not sell or share your personal information with third parties, except in the following cases:</p>
    <ul>
        <li>When required by law or governmental authorities.</li>
        <li>With service providers who help us operate our business (e.g., payment processors or cloud hosting
            providers).</li>
        <li>In case of a merger, acquisition, or sale of assets, your data may be transferred to the new entity.
        </li>
    </ul>

    <h2>4. Cookies</h2>
    <p>We use cookies to enhance your experience. Cookies help us analyze traffic, remember preferences, and improve
        our services. You can disable cookies through your browser settings, but this may limit some functionalities
        of our site.</p>

    <h2>5. Data Security</h2>
    <p>We implement robust security measures to protect your data from unauthorized access, alteration, or
        disclosure. However, no method of transmission over the internet is 100% secure, so we cannot guarantee
        absolute security.</p>

    <h2>6. Your Rights</h2>
    <p>You have the following rights regarding your personal information:</p>
    <ul>
        <li>Access: You can request a copy of the information we have about you.</li>
        <li>Correction: You can request corrections to inaccurate information.</li>
        <li>Deletion: You can request that we delete your data (subject to legal obligations).</li>
        <li>Opt-Out: You can opt out of promotional communications at any time.</li>
    </ul>

    <h2>7. Third-Party Links</h2>
    <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of
        these external sites. Please review their privacy policies independently.</p>

    <h2>8. Changes to This Privacy Policy</h2>
    <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page, and we
        encourage you to review it regularly.</p>

    <h2>9. Contact Us</h2>
    <p>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
    <p>
        Email: <a href="mailto:{{PRIVACY_EMAIL}}">{{PRIVACY_EMAIL}}</a><br>
        Phone: <a href="tel:{{CONTACT_US_PHONE_MAIN}}">{{CONTACT_US_PHONE_MAIN}}</a><br>
        Website: <a href="{{CONTACT_US_WEB_MAIN}}" target="_blank">{{CONTACT_US_WEB_MAIN}}</a>
    </p>
</div>

<div class="col-xs-12" style="height:50px;"></div>
